// extracted by mini-css-extract-plugin
module.exports = {"container":"HeaderDashboardSideBar_container__T4NMl","close":"HeaderDashboardSideBar_close__C8LxT","menu":"HeaderDashboardSideBar_menu__5iaaK"};